import React from 'react'
import * as styles from "../styles/stayintheloop.module.css"
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

export default function StayInTheLoop() {
    const breakpoints = useBreakpoint();
    if (breakpoints.sm) {
        return (
            <section className={styles.containerMobile}>
                <div className={styles.rightSideMobile}>
                    <div className={styles.headerMobile}>
                        <h1 className={styles.titleMobile}>Stay in the loop</h1>
                        <div className={styles.subtitleContainerMobile}>
                            <h1 className={styles.subtitleMobile}>Keep up with our teams and get all the news on our social media platforms.</h1>
                        </div>
                    </div>
                    <div className={styles.contactMobile}>
                        <h1>contactus@geekayesports.com</h1>
                        <h1>+971-4-3361706</h1>
                    </div>
                    <div className={styles.socialsMobile}>
                        <a className={styles.socialCardTwitter} href="https://twitter.com/Geekay_Esports">
                            <div className={styles.socialCardIcon}>
                                <img src="images/icons/twitter.png" alt="Twitter Logo"></img>
                            </div>
                            <div className={styles.socialCardTextBox}>
                                <div className={styles.socialCardTextTwitter}>Follow Us</div>
                                <div className={styles.socialCardTextTwitter}>@Geekay_Esports</div>
                            </div>
                        </a>
                        <a className={styles.socialCardInstagramMobile} href="https://www.instagram.com/geekay_esports/">
                            <div className={styles.socialCardIcon}>
                                <img src="images/icons/instagram.png" alt="instagram Logo"></img>
                            </div>
                            <div className={styles.socialCardTextBox}>
                                <div className={styles.socialCardTextInstagram}>Follow Us</div>
                                <div className={styles.socialCardTextInstagram}>@Geekay_Esports</div>
                            </div>
                        </a>
                        <a className={styles.socialCardDiscordMobile} href="https://discord.gg/uSM56aBz6h">
                            <div className={styles.socialCardIcon}>
                                <img src="images/icons/discord.png" alt="Discord Logo"></img>
                            </div>
                            <div className={styles.socialCardTextBox}>
                                <div className={styles.socialCardTextTwitter}>Join our Discord</div>
                            </div>
                        </a>
                    </div>
                </div>
            </section>
        )
    } else {
        return (
            <section className={styles.container}>
                <div className={styles.leftSide}>
                    <div className={styles.whitebox}>
                    <blockquote class="twitter-tweet" data-dnt="true"><p lang="ar" dir="rtl">الف مبروك لللاعب Ajwad من فريق Geekay Esports لحصوله على لقب افضل لاعب في البطولة. شاهدوا معنا لقطات للحظات كان له دور فعال في تقدم فريقه<a href="https://twitter.com/hashtag/RazerInvitational?src=hash&amp;ref_src=twsrc%5Etfw">#RazerInvitational</a> <a href="https://twitter.com/hashtag/esports?src=hash&amp;ref_src=twsrc%5Etfw">#esports</a> <a href="https://twitter.com/hashtag/%D8%AC%D9%8A%D9%85%D8%B1%D8%B2?src=hash&amp;ref_src=twsrc%5Etfw">#جيمرز</a> <a href="https://twitter.com/hashtag/THISISESPORTS?src=hash&amp;ref_src=twsrc%5Etfw">#THISISESPORTS</a> <a href="https://t.co/trCtfuSjpd">pic.twitter.com/trCtfuSjpd</a></p>&mdash; R Λ Z Ξ R | Middle East (@RazerMENA) <a href="https://twitter.com/RazerMENA/status/1432226810155175941?ref_src=twsrc%5Etfw">August 30, 2021</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                    </div>
                </div>
                <div className={styles.rightSide}>
                    <div className={styles.header}>
                        <h1 className={styles.title}>Stay in the loop</h1>
                        <div className={styles.subtitleContainer}>
                            <h1 className={styles.subtitle}>Keep up with our teams and get all the news on</h1>
                            <h1 className={styles.subtitle}>our social media platforms.</h1>
                        </div>
                    </div>
                    <div className={styles.contact}>
                        <h1>contactus@geekayesports.com</h1>
                        <h1>+971-4-3361706</h1>
                    </div>
                    <div className={styles.socials}>
                        <a className={styles.socialCardTwitter} href="https://twitter.com/Geekay_Esports">
                            <div className={styles.socialCardIcon}>
                                <img src="images/icons/twitter.png" alt="Twitter Logo"></img>
                            </div>
                            <div className={styles.socialCardTextBox}>
                                <div className={styles.socialCardTextTwitter}>Follow Us</div>
                                <div className={styles.socialCardTextTwitter}>@Geekay_Esports</div>
                            </div>
                        </a>
                        <a className={styles.socialCardInstagram} href="https://www.instagram.com/geekay_esports/">
                            <div className={styles.socialCardIcon}>
                                <img src="images/icons/instagram.png" alt="instagram Logo"></img>
                            </div>
                            <div className={styles.socialCardTextBox}>
                                <div className={styles.socialCardTextInstagram}>Follow Us</div>
                                <div className={styles.socialCardTextInstagram}>@Geekay_Esports</div>
                            </div>
                        </a>
                        <a className={styles.socialCardDiscord} href="https://discord.gg/uSM56aBz6h">
                            <div className={styles.socialCardIcon}>
                                <img src="images/icons/discord.png" alt="Discord Logo"></img>
                            </div>
                            <div className={styles.socialCardTextBox}>
                                <div className={styles.socialCardTextTwitter}>Join our Discord</div>
                            </div>
                        </a>
                    </div>
                </div>
            </section>
        )
    }
}
